import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Card,
  Form,
  Button,
  Alert,
  Image,
  ProgressBar
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { 
  FaFacebook, 
  FaLine, 
  FaUser, 
  FaEnvelope, 
  FaLock, 
  FaPhone, 
  FaStore,
  FaCheck
} from "react-icons/fa";

const Register = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    // Step 1: Basic Info
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    
    // Step 2: Facebook Page Info
    pageName: "",
    pageUrl: "",
    pageCategory: "",
    
    // Step 3: Business Info
    businessType: "",
    productCategory: "",
    averageSales: "",
    marketingGoals: [],
    
    // Terms
    agreeTerms: false
  });
  
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("danger");
  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox" && name === "marketingGoals") {
      // Handle multiple checkbox selections for marketing goals
      const updatedGoals = [...formData.marketingGoals];
      if (checked) {
        updatedGoals.push(value);
      } else {
        const index = updatedGoals.indexOf(value);
        if (index > -1) {
          updatedGoals.splice(index, 1);
        }
      }
      
      setFormData({
        ...formData,
        marketingGoals: updatedGoals
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value
      });
    }
  };

  const validateStep = (currentStep) => {
    setValidated(true);
    
    switch(currentStep) {
      case 1:
        if (!formData.name || !formData.email || !formData.password || !formData.phone) {
          return false;
        }
        if (formData.password !== formData.confirmPassword) {
          setAlertVariant("danger");
          setAlertMessage("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน");
          setShowAlert(true);
          return false;
        }
        return true;
        
      case 2:
        if (!formData.pageName || !formData.pageUrl) {
          return false;
        }
        return true;
        
      case 3:
        if (!formData.businessType || !formData.agreeTerms) {
          return false;
        }
        return true;
        
      default:
        return false;
    }
  };

  const handleNext = () => {
    if (validateStep(step)) {
      setShowAlert(false);
      setValidated(false);
      setStep(step + 1);
    }
  };

  const handlePrevious = () => {
    setShowAlert(false);
    setValidated(false);
    setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateStep(step)) {
      // In a real implementation, this would call an API to register the user
      setAlertVariant("success");
      setAlertMessage("สมัครสมาชิกสำเร็จ! กำลังนำคุณไปยังหน้าเข้าสู่ระบบ...");
      setShowAlert(true);
      
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    }
  };

  const handleFacebookRegister = () => {
    // In a real implementation, this would integrate with Facebook Login API
    setAlertVariant("info");
    setAlertMessage("กำลังเชื่อมต่อกับ Facebook...");
    setShowAlert(true);
    
    setTimeout(() => {
      // Simulate getting data from Facebook
      setFormData({
        ...formData,
        name: "Facebook User",
        email: "facebook.user@example.com",
        pageName: "My Facebook Page",
        pageUrl: "https://facebook.com/myfacebookpage"
      });
      setStep(2); // Skip to step 2
      setShowAlert(false);
    }, 2000);
  };

  const handleLineRegister = () => {
    // In a real implementation, this would integrate with LINE Login API
    setAlertVariant("info");
    setAlertMessage("กำลังเชื่อมต่อกับ LINE...");
    setShowAlert(true);
    
    setTimeout(() => {
      // Simulate getting data from LINE
      setFormData({
        ...formData,
        name: "LINE User",
        email: "line.user@example.com"
      });
      setStep(2); // Skip to step 2
      setShowAlert(false);
    }, 2000);
  };

  const renderStepContent = () => {
    switch(step) {
      case 1:
        return (
          <>
            <h5 className="mb-3">ข้อมูลส่วนตัว</h5>
            
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label className="d-flex align-items-center">
                <FaUser className="me-2" /> ชื่อ-นามสกุล
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="กรอกชื่อ-นามสกุล"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอกชื่อ-นามสกุล
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label className="d-flex align-items-center">
                <FaEnvelope className="me-2" /> อีเมล
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="กรอกอีเมล"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอกอีเมลให้ถูกต้อง
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label className="d-flex align-items-center">
                <FaPhone className="me-2" /> เบอร์โทรศัพท์
              </Form.Label>
              <Form.Control
                type="tel"
                placeholder="กรอกเบอร์โทรศัพท์"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอกเบอร์โทรศัพท์
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label className="d-flex align-items-center">
                <FaLock className="me-2" /> รหัสผ่าน
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="กรอกรหัสผ่าน"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอกรหัสผ่าน
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formConfirmPassword">
              <Form.Label className="d-flex align-items-center">
                <FaLock className="me-2" /> ยืนยันรหัสผ่าน
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="กรอกรหัสผ่านอีกครั้ง"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณายืนยันรหัสผ่าน
              </Form.Control.Feedback>
            </Form.Group>
          </>
        );
        
      case 2:
        return (
          <>
            <h5 className="mb-3">ข้อมูลเพจ Facebook</h5>
            
            <Form.Group className="mb-3" controlId="formPageName">
              <Form.Label className="d-flex align-items-center">
                <FaStore className="me-2" /> ชื่อเพจ Facebook
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="กรอกชื่อเพจ Facebook"
                name="pageName"
                value={formData.pageName}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอกชื่อเพจ Facebook
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formPageUrl">
              <Form.Label className="d-flex align-items-center">
                <FaFacebook className="me-2" /> URL เพจ Facebook
              </Form.Label>
              <Form.Control
                type="url"
                placeholder="https://facebook.com/yourpage"
                name="pageUrl"
                value={formData.pageUrl}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                กรุณากรอก URL เพจ Facebook
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formPageCategory">
              <Form.Label>หมวดหมู่เพจ</Form.Label>
              <Form.Select
                name="pageCategory"
                value={formData.pageCategory}
                onChange={handleChange}
              >
                <option value="">เลือกหมวดหมู่</option>
                <option value="สินค้าและบริการ">สินค้าและบริการ</option>
                <option value="ความงามและแฟชั่น">ความงามและแฟชั่น</option>
                <option value="อาหารและเครื่องดื่ม">อาหารและเครื่องดื่ม</option>
                <option value="สุขภาพและการออกกำลังกาย">สุขภาพและการออกกำลังกาย</option>
                <option value="อื่นๆ">อื่นๆ</option>
              </Form.Select>
            </Form.Group>
            
            <div className="d-flex align-items-center mb-3">
              <Button 
                variant="outline-primary" 
                className="d-flex align-items-center justify-content-center"
                onClick={handleFacebookRegister}
              >
                <FaFacebook className="me-2" />
                เชื่อมต่อกับเพจ Facebook
              </Button>
              <span className="text-muted ms-3 small">
                (ไม่จำเป็น แต่แนะนำให้เชื่อมต่อเพื่อความสะดวก)
              </span>
            </div>
          </>
        );
        
      case 3:
        return (
          <>
            <h5 className="mb-3">ข้อมูลธุรกิจ</h5>
            
            <Form.Group className="mb-3" controlId="formBusinessType">
              <Form.Label>ประเภทธุรกิจ</Form.Label>
              <Form.Select
                name="businessType"
                value={formData.businessType}
                onChange={handleChange}
                required
              >
                <option value="">เลือกประเภทธุรกิจ</option>
                <option value="ขายปลีก">ขายปลีก</option>
                <option value="ขายส่ง">ขายส่ง</option>
                <option value="บริการ">บริการ</option>
                <option value="ผลิตสินค้า">ผลิตสินค้า</option>
                <option value="อื่นๆ">อื่นๆ</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                กรุณาเลือกประเภทธุรกิจ
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formProductCategory">
              <Form.Label>หมวดหมู่สินค้า/บริการ</Form.Label>
              <Form.Select
                name="productCategory"
                value={formData.productCategory}
                onChange={handleChange}
              >
                <option value="">เลือกหมวดหมู่</option>
                <option value="เสื้อผ้าและแฟชั่น">เสื้อผ้าและแฟชั่น</option>
                <option value="ความงามและสุขภาพ">ความงามและสุขภาพ</option>
                <option value="อาหารและเครื่องดื่ม">อาหารและเครื่องดื่ม</option>
                <option value="เครื่องใช้ในบ้าน">เครื่องใช้ในบ้าน</option>
                <option value="อิเล็กทรอนิกส์">อิเล็กทรอนิกส์</option>
                <option value="อื่นๆ">อื่นๆ</option>
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formAverageSales">
              <Form.Label>ยอดขายเฉลี่ยต่อเดือน</Form.Label>
              <Form.Select
                name="averageSales"
                value={formData.averageSales}
                onChange={handleChange}
              >
                <option value="">เลือกช่วงยอดขาย</option>
                <option value="น้อยกว่า 50,000 บาท">น้อยกว่า 50,000 บาท</option>
                <option value="50,000 - 100,000 บาท">50,000 - 100,000 บาท</option>
                <option value="100,001 - 500,000 บาท">100,001 - 500,000 บาท</option>
                <option value="500,001 - 1,000,000 บาท">500,001 - 1,000,000 บาท</option>
                <option value="มากกว่า 1,000,000 บาท">มากกว่า 1,000,000 บาท</option>
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>เป้าหมายทางการตลาด (เลือกได้มากกว่า 1 ข้อ)</Form.Label>
              <div>
                <Form.Check
                  type="checkbox"
                  id="goal-awareness"
                  label="เพิ่มการรับรู้แบรนด์"
                  name="marketingGoals"
                  value="เพิ่มการรับรู้แบรนด์"
                  checked={formData.marketingGoals.includes("เพิ่มการรับรู้แบรนด์")}
                  onChange={handleChange}
                  className="mb-2"
                />
                <Form.Check
                  type="checkbox"
                  id="goal-sales"
                  label="เพิ่มยอดขาย"
                  name="marketingGoals"
                  value="เพิ่มยอดขาย"
                  checked={formData.marketingGoals.includes("เพิ่มยอดขาย")}
                  onChange={handleChange}
                  className="mb-2"
                />
                <Form.Check
                  type="checkbox"
                  id="goal-engagement"
                  label="เพิ่มการมีส่วนร่วมกับลูกค้า"
                  name="marketingGoals"
                  value="เพิ่มการมีส่วนร่วมกับลูกค้า"
                  checked={formData.marketingGoals.includes("เพิ่มการมีส่วนร่วมกับลูกค้า")}
                  onChange={handleChange}
                  className="mb-2"
                />
                <Form.Check
                  type="checkbox"
                  id="goal-leads"
                  label="เพิ่มลูกค้าใหม่"
                  name="marketingGoals"
                  value="เพิ่มลูกค้าใหม่"
                  checked={formData.marketingGoals.includes("เพิ่มลูกค้าใหม่")}
                  onChange={handleChange}
                  className="mb-2"
                />
              </div>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="agreeTerms"
                label="ฉันยอมรับเงื่อนไขและข้อตกลงในการใช้บริการ"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                required
                isInvalid={validated && !formData.agreeTerms}
              />
              <Form.Control.Feedback type="invalid">
                กรุณายอมรับเงื่อนไขและข้อตกลง
              </Form.Control.Feedback>
            </Form.Group>
          </>
        );
        
      default:
        return null;
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="border-0">
                <Card.Body>
                  <div className="text-center mb-4">
                    <Image 
                      src="/assets/images/logo.png" 
                      alt="Ruaysure Logo" 
                      height={60} 
                      className="mb-3"
                    />
                    <h4>สมัครสมาชิก</h4>
                    <p className="text-muted">สมัครสมาชิกเพื่อใช้บริการ Ruaysure</p>
                  </div>
                  
                  {showAlert && (
                    <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
                      {alertMessage}
                    </Alert>
                  )}
                  
                  {step === 1 && (
                    <div className="mb-4">
                      <Button 
                        variant="primary" 
                        className="w-100 mb-2 d-flex align-items-center justify-content-center"
                        onClick={handleFacebookRegister}
                      >
                        <FaFacebook className="me-2" size={20} />
                        สมัครด้วย Facebook
                      </Button>
                      
                      <Button 
                        variant="success" 
                        className="w-100 d-flex align-items-center justify-content-center"
                        onClick={handleLineRegister}
                      >
                        <FaLine className="me-2" size={20} />
                        สมัครด้วย LINE
                      </Button>
                      
                      <div className="position-relative my-4">
                        <hr />
                        <p className="small position-absolute top-50 start-50 translate-middle bg-white px-2">หรือ</p>
                      </div>
                    </div>
                  )}
                  
                  <div className="mb-4">
                    <ProgressBar 
                      now={(step / 3) * 100} 
                      variant="primary" 
                      className="mb-2"
                    />
                    <div className="d-flex justify-content-between">
                      <div className={`step-indicator ${step >= 1 ? 'active' : ''}`}>
                        <span className="step-number">1</span>
                        <span className="step-title d-none d-md-inline">ข้อมูลส่วนตัว</span>
                      </div>
                      <div className={`step-indicator ${step >= 2 ? 'active' : ''}`}>
                        <span className="step-number">2</span>
                        <span className="step-title d-none d-md-inline">ข้อมูลเพจ</span>
                      </div>
                      <div className={`step-indicator ${step >= 3 ? 'active' : ''}`}>
                        <span className="step-number">3</span>
                        <span className="step-title d-none d-md-inline">ข้อมูลธุรกิจ</span>
                      </div>
                    </div>
                  </div>
                  
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    {renderStepContent()}
                    
                    <div className="d-flex justify-content-between mt-4">
                      {step > 1 && (
                        <Button variant="outline-secondary" onClick={handlePrevious}>
                          ย้อนกลับ
                        </Button>
                      )}
                      
                      {step < 3 ? (
                        <Button 
                          variant="primary" 
                          className={`${step === 1 ? 'ms-auto' : ''}`}
                          onClick={handleNext}
                        >
                          ถัดไป
                        </Button>
                      ) : (
                        <Button variant="primary" type="submit">
                          <FaCheck className="me-2" /> ยืนยันการสมัคร
                        </Button>
                      )}
                    </div>
                  </Form>
                  
                  <div className="text-center mt-4">
                    <p className="mb-0">มีบัญชีอยู่แล้ว? <Link to="/login" className="text-primary">เข้าสู่ระบบ</Link></p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Register;
